// src/services/CountryService.js
import api from "./api";

export function getAccommodationBed(page = 1, limit = 10, search = "") {
  return api.get(`/accommodationbed?page=${page}&limit=${limit}&search=${search}`);
}

export function getAccommodationBedById(id) {
  return api.get(`/accommodationbed/${id}`);
}

export function addAccommodationBed(data) {
  return api.post("/accommodationbed", data);
}

export function updateAccommodationBed(id, data) {
  return api.put(`/accommodationbed/${id}`, data);
}

export function deleteAccommodationBed(id) {
  return api.delete(`/accommodationbed/${id}`);
}
